import { phone_mask_US_format } from '../utils/commonUtil';
import { isEmpty } from 'lodash';
export default function PhoneNumbersList({ phoneNumbers }) {
  return (
    <div>
      {!isEmpty(phoneNumbers) ? (
        <div className='mb-4 flex-row space-y-1.5'>
          <div className='go-label-16'>
            {phoneNumbers?.[0]?.type
              ? phoneNumbers?.[0]?.type?.charAt(0).toUpperCase() + phoneNumbers?.[0]?.type?.slice(1).toLowerCase()
              : 'Phone'}
          </div>
          <div className='go-textblacknormal-16 font-medium'>
            {phone_mask_US_format(phoneNumbers?.[0]?.phone_number)?.formatted}
          </div>
        </div>
      ) : (
        <div className='flex-row items-center'>
          <div className='go-label-16'>Phone Number</div>
          <div className='go-textblacknormal-16 font-medium'>-</div>
        </div>
      )}
    </div>
  );
}
